// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as HarikaradminRouteImport } from './routes/harikaradmin'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MenuRouteImport } from './routes/menu'
import { Route as PointsRouteImport } from './routes/points'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ReservationsRouteImport } from './routes/reservations'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as EventsEventIdRouteImport } from './routes/events.$eventId'
import { Route as HarikaradminIndexRouteImport } from './routes/harikaradmin.index'
import { Route as HarikaradminActivityRouteImport } from './routes/harikaradmin.activity'
import { Route as HarikaradminAdminsRouteImport } from './routes/harikaradmin.admins'
import { Route as HarikaradminBrandingRouteImport } from './routes/harikaradmin.branding'
import { Route as HarikaradminDrinksRouteImport } from './routes/harikaradmin.drinks'
import { Route as HarikaradminDrinksReportRouteImport } from './routes/harikaradmin.drinks-report'
import { Route as HarikaradminEmailsRouteImport } from './routes/harikaradmin.emails'
import { Route as HarikaradminEventsRouteImport } from './routes/harikaradmin.events'
import { Route as HarikaradminEventsReportRouteImport } from './routes/harikaradmin.events-report'
import { Route as HarikaradminGrantTicketRouteImport } from './routes/harikaradmin.grant-ticket'
import { Route as HarikaradminLikesRouteImport } from './routes/harikaradmin.likes'
import { Route as HarikaradminMembersReportRouteImport } from './routes/harikaradmin.members-report'
import { Route as HarikaradminPackagesRouteImport } from './routes/harikaradmin.packages'
import { Route as HarikaradminPaymentsRouteImport } from './routes/harikaradmin.payments'
import { Route as HarikaradminPointsRouteImport } from './routes/harikaradmin.points'
import { Route as HarikaradminPointsReportRouteImport } from './routes/harikaradmin.points-report'
import { Route as HarikaradminReservationsRouteImport } from './routes/harikaradmin.reservations'
import { Route as HarikaradminScanRouteImport } from './routes/harikaradmin.scan'
import { Route as HarikaradminSendEmailRouteImport } from './routes/harikaradmin.send-email'
import { Route as HarikaradminShopierRouteImport } from './routes/harikaradmin.shopier'
import { Route as HarikaradminTransfersRouteImport } from './routes/harikaradmin.transfers'
import { Route as HarikaradminWaitersRouteImport } from './routes/harikaradmin.waiters'
import { Route as PointsIndexRouteImport } from './routes/points.index'
import { Route as TicketsIndexRouteImport } from './routes/tickets.index'
import { Route as TicketsTicketIdRouteImport } from './routes/tickets.$ticketId'
import { Route as VouchersIndexRouteImport } from './routes/vouchers.index'
import { Route as VouchersVoucherIdRouteImport } from './routes/vouchers.$voucherId'
import { Route as YasalEtkinlikKurallariRouteImport } from './routes/yasal.etkinlik-kurallari'
import { Route as YasalIadeIptalRouteImport } from './routes/yasal.iade-iptal'
import { Route as YasalIletisimRouteImport } from './routes/yasal.iletisim'
import { Route as YasalKvkkRouteImport } from './routes/yasal.kvkk'
import { Route as YasalMesafeliSatisSozlesmesiRouteImport } from './routes/yasal.mesafeli-satis-sozlesmesi'
import { Route as YasalOnBilgilendirmeRouteImport } from './routes/yasal.on-bilgilendirme'
import { Route as EventsEventIdDrinksRouteImport } from './routes/events.$eventId.drinks'
import { Route as HarikaradminEventsReportIndexRouteImport } from './routes/harikaradmin.events-report.index'
import { Route as HarikaradminEventsReportEventIdRouteImport } from './routes/harikaradmin.events-report.$eventId'
import { Route as HarikaradminEventsIndexRouteImport } from './routes/harikaradmin.events.index'
import { Route as HarikaradminEventsEventIdRouteImport } from './routes/harikaradmin.events.$eventId'
import { Route as HarikaradminMembersUserIdRouteImport } from './routes/harikaradmin.members.$userId'
import { Route as HarikaradminMonitorEventIdRouteImport } from './routes/harikaradmin.monitor.$eventId'
import { Route as OrdersOrderIdShopierRouteImport } from './routes/orders.$orderId.shopier'
import { Route as PointsCheckoutOrderIdRouteImport } from './routes/points.checkout.$orderId'
import { Route as EventsEventIdCheckoutTicketTypeIdRouteImport } from './routes/events.$eventId.checkout.$ticketTypeId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const HarikaradminRoute = HarikaradminRouteImport.update({
            id: '/harikaradmin',path: '/harikaradmin',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MenuRoute = MenuRouteImport.update({
            id: '/menu',path: '/menu',getParentRoute: () => rootRouteImport
          })
const PointsRoute = PointsRouteImport.update({
            id: '/points',path: '/points',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const ReservationsRoute = ReservationsRouteImport.update({
            id: '/reservations',path: '/reservations',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const EventsIndexRoute = EventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => rootRouteImport
          })
const EventsEventIdRoute = EventsEventIdRouteImport.update({
            id: '/events/$eventId',path: '/events/$eventId',getParentRoute: () => rootRouteImport
          })
const HarikaradminIndexRoute = HarikaradminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminActivityRoute = HarikaradminActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminAdminsRoute = HarikaradminAdminsRouteImport.update({
            id: '/admins',path: '/admins',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminBrandingRoute = HarikaradminBrandingRouteImport.update({
            id: '/branding',path: '/branding',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminDrinksRoute = HarikaradminDrinksRouteImport.update({
            id: '/drinks',path: '/drinks',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminDrinksReportRoute = HarikaradminDrinksReportRouteImport.update({
            id: '/drinks-report',path: '/drinks-report',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminEmailsRoute = HarikaradminEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminEventsRoute = HarikaradminEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminEventsReportRoute = HarikaradminEventsReportRouteImport.update({
            id: '/events-report',path: '/events-report',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminGrantTicketRoute = HarikaradminGrantTicketRouteImport.update({
            id: '/grant-ticket',path: '/grant-ticket',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminLikesRoute = HarikaradminLikesRouteImport.update({
            id: '/likes',path: '/likes',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminMembersReportRoute = HarikaradminMembersReportRouteImport.update({
            id: '/members-report',path: '/members-report',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminPackagesRoute = HarikaradminPackagesRouteImport.update({
            id: '/packages',path: '/packages',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminPaymentsRoute = HarikaradminPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminPointsRoute = HarikaradminPointsRouteImport.update({
            id: '/points',path: '/points',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminPointsReportRoute = HarikaradminPointsReportRouteImport.update({
            id: '/points-report',path: '/points-report',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminReservationsRoute = HarikaradminReservationsRouteImport.update({
            id: '/reservations',path: '/reservations',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminScanRoute = HarikaradminScanRouteImport.update({
            id: '/scan',path: '/scan',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminSendEmailRoute = HarikaradminSendEmailRouteImport.update({
            id: '/send-email',path: '/send-email',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminShopierRoute = HarikaradminShopierRouteImport.update({
            id: '/shopier',path: '/shopier',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminTransfersRoute = HarikaradminTransfersRouteImport.update({
            id: '/transfers',path: '/transfers',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminWaitersRoute = HarikaradminWaitersRouteImport.update({
            id: '/waiters',path: '/waiters',getParentRoute: () => HarikaradminRoute
          })
const PointsIndexRoute = PointsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PointsRoute
          })
const TicketsIndexRoute = TicketsIndexRouteImport.update({
            id: '/tickets/',path: '/tickets/',getParentRoute: () => rootRouteImport
          })
const TicketsTicketIdRoute = TicketsTicketIdRouteImport.update({
            id: '/tickets/$ticketId',path: '/tickets/$ticketId',getParentRoute: () => rootRouteImport
          })
const VouchersIndexRoute = VouchersIndexRouteImport.update({
            id: '/vouchers/',path: '/vouchers/',getParentRoute: () => rootRouteImport
          })
const VouchersVoucherIdRoute = VouchersVoucherIdRouteImport.update({
            id: '/vouchers/$voucherId',path: '/vouchers/$voucherId',getParentRoute: () => rootRouteImport
          })
const YasalEtkinlikKurallariRoute = YasalEtkinlikKurallariRouteImport.update({
            id: '/yasal/etkinlik-kurallari',path: '/yasal/etkinlik-kurallari',getParentRoute: () => rootRouteImport
          })
const YasalIadeIptalRoute = YasalIadeIptalRouteImport.update({
            id: '/yasal/iade-iptal',path: '/yasal/iade-iptal',getParentRoute: () => rootRouteImport
          })
const YasalIletisimRoute = YasalIletisimRouteImport.update({
            id: '/yasal/iletisim',path: '/yasal/iletisim',getParentRoute: () => rootRouteImport
          })
const YasalKvkkRoute = YasalKvkkRouteImport.update({
            id: '/yasal/kvkk',path: '/yasal/kvkk',getParentRoute: () => rootRouteImport
          })
const YasalMesafeliSatisSozlesmesiRoute = YasalMesafeliSatisSozlesmesiRouteImport.update({
            id: '/yasal/mesafeli-satis-sozlesmesi',path: '/yasal/mesafeli-satis-sozlesmesi',getParentRoute: () => rootRouteImport
          })
const YasalOnBilgilendirmeRoute = YasalOnBilgilendirmeRouteImport.update({
            id: '/yasal/on-bilgilendirme',path: '/yasal/on-bilgilendirme',getParentRoute: () => rootRouteImport
          })
const EventsEventIdDrinksRoute = EventsEventIdDrinksRouteImport.update({
            id: '/drinks',path: '/drinks',getParentRoute: () => EventsEventIdRoute
          })
const HarikaradminEventsReportIndexRoute = HarikaradminEventsReportIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HarikaradminEventsReportRoute
          })
const HarikaradminEventsReportEventIdRoute = HarikaradminEventsReportEventIdRouteImport.update({
            id: '/$eventId',path: '/$eventId',getParentRoute: () => HarikaradminEventsReportRoute
          })
const HarikaradminEventsIndexRoute = HarikaradminEventsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HarikaradminEventsRoute
          })
const HarikaradminEventsEventIdRoute = HarikaradminEventsEventIdRouteImport.update({
            id: '/$eventId',path: '/$eventId',getParentRoute: () => HarikaradminEventsRoute
          })
const HarikaradminMembersUserIdRoute = HarikaradminMembersUserIdRouteImport.update({
            id: '/members/$userId',path: '/members/$userId',getParentRoute: () => HarikaradminRoute
          })
const HarikaradminMonitorEventIdRoute = HarikaradminMonitorEventIdRouteImport.update({
            id: '/monitor/$eventId',path: '/monitor/$eventId',getParentRoute: () => HarikaradminRoute
          })
const OrdersOrderIdShopierRoute = OrdersOrderIdShopierRouteImport.update({
            id: '/orders/$orderId/shopier',path: '/orders/$orderId/shopier',getParentRoute: () => rootRouteImport
          })
const PointsCheckoutOrderIdRoute = PointsCheckoutOrderIdRouteImport.update({
            id: '/checkout/$orderId',path: '/checkout/$orderId',getParentRoute: () => PointsRoute
          })
const EventsEventIdCheckoutTicketTypeIdRoute = EventsEventIdCheckoutTicketTypeIdRouteImport.update({
            id: '/checkout/$ticketTypeId',path: '/checkout/$ticketTypeId',getParentRoute: () => EventsEventIdRoute
          })





const HarikaradminEventsRouteChildren = {
  HarikaradminEventsEventIdRoute: HarikaradminEventsEventIdRoute,HarikaradminEventsIndexRoute: HarikaradminEventsIndexRoute
}

const HarikaradminEventsRouteWithChildren = HarikaradminEventsRoute._addFileChildren(HarikaradminEventsRouteChildren)




const HarikaradminEventsReportRouteChildren = {
  HarikaradminEventsReportEventIdRoute: HarikaradminEventsReportEventIdRoute,HarikaradminEventsReportIndexRoute: HarikaradminEventsReportIndexRoute
}

const HarikaradminEventsReportRouteWithChildren = HarikaradminEventsReportRoute._addFileChildren(HarikaradminEventsReportRouteChildren)



const HarikaradminRouteChildren = {
  HarikaradminActivityRoute: HarikaradminActivityRoute,HarikaradminAdminsRoute: HarikaradminAdminsRoute,HarikaradminBrandingRoute: HarikaradminBrandingRoute,HarikaradminDrinksRoute: HarikaradminDrinksRoute,HarikaradminDrinksReportRoute: HarikaradminDrinksReportRoute,HarikaradminEmailsRoute: HarikaradminEmailsRoute,HarikaradminEventsRoute: HarikaradminEventsRouteWithChildren,HarikaradminEventsReportRoute: HarikaradminEventsReportRouteWithChildren,HarikaradminGrantTicketRoute: HarikaradminGrantTicketRoute,HarikaradminLikesRoute: HarikaradminLikesRoute,HarikaradminMembersReportRoute: HarikaradminMembersReportRoute,HarikaradminPackagesRoute: HarikaradminPackagesRoute,HarikaradminPaymentsRoute: HarikaradminPaymentsRoute,HarikaradminPointsRoute: HarikaradminPointsRoute,HarikaradminPointsReportRoute: HarikaradminPointsReportRoute,HarikaradminReservationsRoute: HarikaradminReservationsRoute,HarikaradminScanRoute: HarikaradminScanRoute,HarikaradminSendEmailRoute: HarikaradminSendEmailRoute,HarikaradminShopierRoute: HarikaradminShopierRoute,HarikaradminTransfersRoute: HarikaradminTransfersRoute,HarikaradminWaitersRoute: HarikaradminWaitersRoute,HarikaradminIndexRoute: HarikaradminIndexRoute,HarikaradminMembersUserIdRoute: HarikaradminMembersUserIdRoute,HarikaradminMonitorEventIdRoute: HarikaradminMonitorEventIdRoute
}

const HarikaradminRouteWithChildren = HarikaradminRoute._addFileChildren(HarikaradminRouteChildren)




const PointsRouteChildren = {
  PointsIndexRoute: PointsIndexRoute,PointsCheckoutOrderIdRoute: PointsCheckoutOrderIdRoute
}

const PointsRouteWithChildren = PointsRoute._addFileChildren(PointsRouteChildren)




const EventsEventIdRouteChildren = {
  EventsEventIdDrinksRoute: EventsEventIdDrinksRoute,EventsEventIdCheckoutTicketTypeIdRoute: EventsEventIdCheckoutTicketTypeIdRoute
}

const EventsEventIdRouteWithChildren = EventsEventIdRoute._addFileChildren(EventsEventIdRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,DashboardRoute: DashboardRoute,ForgotPasswordRoute: ForgotPasswordRoute,HarikaradminRoute: HarikaradminRouteWithChildren,LoginRoute: LoginRoute,MenuRoute: MenuRoute,PointsRoute: PointsRouteWithChildren,ProfileRoute: ProfileRoute,ReservationsRoute: ReservationsRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRoute,UnsubscribeRoute: UnsubscribeRoute,EventsEventIdRoute: EventsEventIdRouteWithChildren,TicketsTicketIdRoute: TicketsTicketIdRoute,VouchersVoucherIdRoute: VouchersVoucherIdRoute,YasalEtkinlikKurallariRoute: YasalEtkinlikKurallariRoute,YasalIadeIptalRoute: YasalIadeIptalRoute,YasalIletisimRoute: YasalIletisimRoute,YasalKvkkRoute: YasalKvkkRoute,YasalMesafeliSatisSozlesmesiRoute: YasalMesafeliSatisSozlesmesiRoute,YasalOnBilgilendirmeRoute: YasalOnBilgilendirmeRoute,EventsIndexRoute: EventsIndexRoute,TicketsIndexRoute: TicketsIndexRoute,VouchersIndexRoute: VouchersIndexRoute,OrdersOrderIdShopierRoute: OrdersOrderIdShopierRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)